import { Fragment } from "react"
import PropTypes from "prop-types"
import SectionHeader from "./SectionHeader"
import AttendeeEmergencyContact from "./AttendeeEmergencyContact"
import AttendeeQuestions from "./AttendeeQuestions"
import MissingAttendeeInfoError from "./MissingAttendeeInfoError"

const AttendeePersonalInfo = ({ attendee, event, isAdmin }) => {
  return (
    <div className="line p-2">
      <SectionHeader
        title="Personal information"
        buttonAttrs={attendee.person && { "data-person-modal-id": attendee.person.accountCenterId }}
        buttonText="Edit profile"
      />

      <dl>
        {event.profileCollect !== "attendee_name" &&
          attendee.requiredFields.map(field => {
            if (field.name !== "emergency_contact") {
              return (
                <Fragment key={field.name}>
                  <dt
                    className={`reg-details__label ${
                      field.isPopulated ? "d-n@print" : "d-n@print reg-details__item-incomplete"
                    }`}
                  >
                    {field.humanize}
                  </dt>
                  <dd className="mb-1">
                    {field.isPopulated ? (
                      field.nameToS
                    ) : (
                      <MissingAttendeeInfoError errorString="Not provided" />
                    )}
                  </dd>
                </Fragment>
              )
            }
          })}

        {attendee.person && attendee.optionalFields.find(field => field.name === "medical") && (
          <>
            <dt
              className={`reg-details__label ${!attendee.person.medicalNotes ? "d-n@print" : ""}`}
            >
              Medical notes
            </dt>
            <dd className={`mb-1 ${!attendee.person.medicalNotes ? "d-n@print" : ""}`}>
              {attendee.person.medicalNotes ? (
                attendee.person.medicalNotes
              ) : (
                <MissingAttendeeInfoError showErrorExplanation={false} />
              )}
            </dd>
          </>
        )}

        {attendee.isVisibleEmergencyContact && (
          <AttendeeEmergencyContact attendee={attendee} isAdmin={isAdmin} />
        )}

        {attendee.questionsAnswered.length > 0 && (
          <>
            <SectionHeader
              title="Attendee questions"
              buttonAttrs={{ "data-modal-url": attendee.paths.editAttendeeQuestions }}
              buttonPath={attendee.paths.editAttendeeQuestions}
              buttonText="Edit answers"
            />
            <AttendeeQuestions questions={attendee.questionsAnswered} />
          </>
        )}

        {attendee.formQuestionsAnswered.length > 0 && (
          <>
            <SectionHeader
              title="Attendee information form"
              buttonAttrs={{ "data-modal-url": attendee.paths.editAttendeeFormQuestions }}
              buttonText="Edit answers"
            />

            <AttendeeQuestions questions={attendee.formQuestionsAnswered} />
          </>
        )}
      </dl>
    </div>
  )
}

AttendeePersonalInfo.propTypes = {
  attendee: PropTypes.shape({
    questionsAnswered: PropTypes.array,
    formQuestionsAnswered: PropTypes.array,
    requiredFields: PropTypes.array,
    optionalFields: PropTypes.array,
    person: PropTypes.shape({
      medicalNotes: PropTypes.string,
      accountCenterId: PropTypes.number
    }),
    isVisibleEmergencyContact: PropTypes.bool,
    paths: PropTypes.shape({
      editAttendeeQuestions: PropTypes.string,
      editAttendeeFormQuestions: PropTypes.string
    })
  }),
  event: PropTypes.shape({
    hasAttendeeQuestions: PropTypes.bool,
    profileCollect: PropTypes.string
  }),
  isAdmin: PropTypes.bool
}

export default AttendeePersonalInfo
